import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter, Subscription } from 'rxjs';
import { externalPartnersUrls } from './external-partners-url';

@Component({
  selector: 'app-navbar-link',
  template: `
    <a
      [routerLink]="link"
      [routerLinkActive]="activeClass"
      [routerLinkActiveOptions]="{ exact: link === '/' }"
      [class]="navLinkClass"
      [ngClass]="{ 'active':isPartnersPage }"
      title="{{ title | translate }}"
      (click)="onNavigate.emit()"
      >{{ title | translate }}
      </a
    >
  `,
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarLinkComponent implements OnDestroy {
  @Input() title!: string;
  @Input() link!: string;
  @Input() activeClass = 'active';
  @Input() navLinkClass = 'nav-link';
  @Output() onNavigate = new EventEmitter<void>();
  private routerChangeSubs!: Subscription;
  isPartnersPage = false;
  constructor(private router: Router) {}
  ngOnInit() {
    this.addRouteListener();
  }
  private addRouteListener() {
    if(!this.link.includes('partner')) {
      return;
    }
    this.routerChangeSubs = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event:any) => {
        // Checking if the current route matches any of the external partners URLs.
        this.isPartnersPage = Object.values(externalPartnersUrls).some(
          (url) => (<NavigationEnd>event).url === `/${url}`
        );
      });
  }
  ngOnDestroy() {
    this.routerChangeSubs?.unsubscribe();
  }
}
